export const SET_COURSES = "SET_COURSES";

export const GET_COURSES = "GET_COURSES";

export const COURSE_SUCCESS = "COURSE_SUCCESS";

export const ADMIN_COURSE_CRUD_STATUS = "ADMIN_COURSE_CRUD_STATUS"; 

export const ALL_BATCHES = "ALL_BATCHES"; 